import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SponsorStudy } from '../sponsor-dashboard/sponsor-study';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserPermissions } from '../user-permissions/user-permissions';
import { routeData } from '../shared/route-helpers';
import { SponsorSubjectsStorage } from './sponsor-subjects-storage';

@Injectable()
export class SponsorRouteData {

    public readonly snapshot: {
        selectedStudy: SponsorStudy,
        studyPermissions: UserPermissions
    };

    public readonly selectedStudy: Observable<SponsorStudy>;
    public readonly studyPermissions: Observable<UserPermissions>;

    constructor(activatedRoute: ActivatedRoute,
                private storage: SponsorSubjectsStorage) {
        this.snapshot = {
            selectedStudy: activatedRoute.snapshot.data[routeData.selectedStudy],
            studyPermissions: activatedRoute.snapshot.data[routeData.studyPermissions],
        };

        this.selectedStudy = activatedRoute.data.pipe(
            map(data => data[routeData.selectedStudy] as SponsorStudy)
        );

        this.studyPermissions = activatedRoute.data.pipe(
            map(data => data[routeData.studyPermissions] as UserPermissions)
        );

        this.storage.getCTProtocolId(this.snapshot.selectedStudy.protocolName, this.snapshot.selectedStudy.sponsorName).subscribe(id => {
            this.snapshot.selectedStudy.ctProtocolId = id;
        });
    }
}